import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType, onMounted } from 'vue'
import { decrypt } from '@/utils/crypto'
import { ElementTypes } from '@/types/slides'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
// import { Axis } from './types'
import { Axis } from '@/components/Contextmenu/types'

import FloatingMenuContent from './FloatingMenuContent.vue'
import ImageMenuContent from './ImageMenuContent.vue'
// import { ToolbarStates } from '@/types/toolbar'
import { ClickmenuItemArray } from './types'

// interface ElementTabs {
//   label: string
//   value: ToolbarStates
// }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  axis: {
    type: Object as PropType<Axis>,
    required: true,
  },
  el: {
    type: Object as PropType<HTMLElement>,
    required: true,
  },
  menus: {
    type: Object as PropType<ClickmenuItemArray>,
    required: true,
  },
  removeContextmenu: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props

const mainStore = useMainStore()
// activeElementIdList: 当前选中元素 id 列表
// handleElement: 当前选中元素
// toolbarState: 当前工具栏状态
const { handleElement, editorAreaFocus } = storeToRefs(mainStore)

const style = computed(() => {
  // debugger
  let MENU_WIDTH = 470 // 菜单宽度
  if (ElementTypes.IMAGE === handleElement.value?.type) {
    MENU_WIDTH = 170 // 图片菜单宽度
  }
  // const MENU_HEIGHT = 40 // 菜单高度
  // const DIVIDER_HEIGHT = 11 // 分割线高度
  // const PADDING = 5 // 内边距
  const EditorPAD = 32 // 容器外边距
  const MAGDING = 10 // 预留边距
  
  const { x, y } = props.axis
  // // menuCount: 菜单项数量
  // const menuCount = props.menus.filter(menu => !(menu.divider || menu.hide)).length
  // // dividerCount: 分割线数量
  // const dividerCount = props.menus.filter(menu => menu.divider).length
  
  const menuWidth = MENU_WIDTH
  //   const menuHeight = menuCount * MENU_HEIGHT + dividerCount * DIVIDER_HEIGHT + PADDING * 2
  // const menuHeight = MENU_HEIGHT
  
  const screenWidth = document.body.clientWidth
  // const screenHeight = document.body.clientHeight

  const remain = menuWidth / 2
  const floatLeft = screenWidth <= x + remain + MAGDING ? x - (remain + (x + remain + EditorPAD - screenWidth)) : x - menuWidth / 2
  // const floatTop = screenHeight <= y + menuHeight ? y - menuHeight : y
  const floatTop = y + 20

  // const floatLeft = screenWidth <= x + menuWidth ? x - menuWidth : x
  // const floatTop = screenHeight <= y + menuHeight ? y - menuHeight : y
  // console.log('floatLeft', floatLeft, 'floatTop', floatTop)
  
  return {
    left: floatLeft,
    top: floatTop,
  }
})

const currentPanelComponent = computed(() => {
  if (ElementTypes.IMAGE === handleElement.value?.type) {
    return ImageMenuContent
  }
  return FloatingMenuContent || null
})

onMounted(() => {
  window.addEventListener('message', listenMessage)
})

const listenMessage = (event: MessageEvent) => {
  // 验证来源，增加安全性
  // if (event.origin !== 'http://localhost:8081' && event.origin !== window.Glob.VUE_APP_ORIGIN) {
  if (!window.Glob.VUE_APP_ORIGIN.some((o: string) => o === event.origin)) {
    return
  }
  const messageF = event.data
  if (messageF) {
    const decryptedMessage = decrypt(messageF)
    const data = JSON.parse(decryptedMessage)
    if (data.msgType && data.msgType === 'ActiveElementIdNull') {
      props.removeContextmenu()
      // 清除编辑区选中
      mainStore.setActiveElementIdList([])
      if (editorAreaFocus.value) mainStore.setEditorareaFocus(false)
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "actionmenu",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (__props.removeContextmenu()), ["prevent"])),
      onMousedown: _cache[1] || (_cache[1] = ($event: any) => (__props.removeContextmenu()))
    }, null, 32),
    _createElementVNode("div", {
      class: "clickmenu",
      style: _normalizeStyle({
      left: style.value.left + 'px',
      top: style.value.top + 'px',
    }),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(currentPanelComponent.value)))
    ], 4)
  ], 64))
}
}

})